@if (
  rejectedAccounts.length &&
  ( isCashPlusEnabled$ | async) &&
  {
    isDigitalAdvice: isDigitalAdvice$ | async,
  }; as view
) {
  <p class="c11n-text-sm">
    <button (click)="ineligibleAccounts.openModalDialog($event)" data-cy="ineligible-accounts">
      {{ content.buttonText }}
    </button>
  </p>

  <c11n-modal-dialog [headingText]="content.modalHeader" [primaryButtonLabel]="content.ok"
    (primaryClick)="ineligibleAccounts.closeDialogModal()" #ineligibleAccounts>
    <div c11n-modal-dialog-body class="c11n-details__content c11n-text-sm c11n-space-stack-3x c11n-space--force">
      <p class="c11n-text-md c11n-space-stack-2x" [innerHTML]="getModalContent()"></p>
      @for (reason of rejectionReasons; track reason) {
        @if(getIneligibleAccountsByReason(reason).length > 0 && getRejectionReasonText(reason, view.isDigitalAdvice)) {
        <div class="c11n-space-stack-0_5x">
          <strong class="c11n-link--reinforced"
            [innerHTML]="getRejectionReasonText(reason, view.isDigitalAdvice)"></strong>
        </div>
        <div class="c11n-space-stack-2x">
          @for(account of getIneligibleAccountsByReason(reason); track account) {
          <p class="c11n-space-stack-0_5x">
            {{ account.formattedAccountName }}
          </p>
          }
        </div>
        }
      }
    </div>
  </c11n-modal-dialog>
}